import Image from 'next/image';
import cn from 'classnames';
import { UiTitle, UiButton } from 'znanie-uikit';

import minionImg from './images/minion.png';

import css from './NoData.module.scss';

interface IProps {
  text?: string;
  btnText?: string;

  onBtnClick?(): void;

  className?: string;
}

export default function NoData({
  text = 'Данные не найдены',
  btnText,
  onBtnClick,
  className,
}: IProps) {
  return (
    <div className={cn(css.block, className)}>
      <div className={css.content}>
        <div className={css.img}>
          <Image src={minionImg} layout="fill" alt="изображение миньона" />
        </div>
        <UiTitle className={css.title} as="h2" align="center" size="large">
          {text}
        </UiTitle>
        {btnText && (
          <div className={css.btn}>
            <UiButton
              fluid
              weight="normal"
              variant="outline"
              onClick={() => {
                onBtnClick && onBtnClick();
              }}
            >
              {btnText}
            </UiButton>
          </div>
        )}
      </div>
    </div>
  );
}
